import * as React from "react";
import { ChevronDownIcon } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * A native `<select>` on the kit's field geometry.
 *
 * Forms that tests drive with `selectOptions` or a change event keep the
 * native element; this gives it the Input's height, radius, line, surface,
 * focus ring, and the 1 rem floor that keeps iOS from zooming, plus the same
 * chevron the Radix Select trigger shows. The element itself is unchanged for
 * labels, ids, and assistive technology.
 */
function NativeSelect({ className, children, ...props }: React.ComponentProps<"select">) {
  return (
    <span data-slot="native-select" className={cn("relative grid min-w-0", className)}>
      <select
        data-slot="native-select-control"
        className="h-[var(--control-height)] w-full min-w-0 appearance-none rounded-control border border-input bg-card ps-3 pe-9 text-[1rem] text-foreground outline-none transition-[color,box-shadow] duration-[var(--motion-fast)] ease-[var(--ease-standard)] focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive md:text-ui"
        {...props}
      >
        {children}
      </select>
      <ChevronDownIcon aria-hidden="true" strokeWidth={1.75} className="pointer-events-none absolute end-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
    </span>
  );
}

export { NativeSelect };
